const HYPHEN_CHAR_INDEX = 1;
export const convertApplication = (application) => 
// Replace hyphens with spaces and capitalize the first letter of each word (camelCase)
// e.g. "data-station" -> "dataStation"
application.replace(/-./g, (char) => char.charAt(HYPHEN_CHAR_INDEX).toUpperCase());
